export default "__VITE_ASSET__78e5d811__"